module.exports = __webpack_public_path__ + "img/kjjh_gallery4.2109320d.jpg";